// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__IzR92","lds-ellipsis1":"style_lds-ellipsis1__gsWry","lds-ellipsis2":"style_lds-ellipsis2__E3+ls","lds-ellipsis3":"style_lds-ellipsis3__D9-jW"};